import AuthPage from '@/pages/AuthPage.vue'
import LoginPage from '@/pages/LoginPage.vue'

const authRoutes = [
    {
        path: '/auth', component: AuthPage, name: 'auth', meta: { requiredAuth: false }
    },
    {
        path: '/login', component: LoginPage, name: 'login', meta: { requiredAuth: false }
    }
]

export default authRoutes;